import { useRef, useState } from "react";
import { Form, Input, Modal, type InputRef } from "antd";
import { slugifyForSave, slugifyWhileTyping } from "./slugInput";

import { type SalesFunnel } from "@fitness-app/data-models/entities/SalesFunnel";

interface DuplicateSalesFunnelModalProps {
  funnel: SalesFunnel | null;
  isSaving?: boolean;
  onCancel: () => void;
  onSubmit: (funnel: SalesFunnel, slug: string) => Promise<"success" | "error">;
}

export const DuplicateSalesFunnelModal = ({ funnel, isSaving, onCancel, onSubmit }: DuplicateSalesFunnelModalProps) => {
  const [slug, setSlug] = useState("");
  const inputRef = useRef<InputRef>(null);

  const finalSlug = slugifyForSave(slug);

  const submit = async () => {
    if (!funnel || !finalSlug) {
      return;
    }

    if ((await onSubmit(funnel, finalSlug)) === "success") {
      setSlug("");
    }
  };

  return (
    <Modal
      open={Boolean(funnel)}
      title={funnel ? `Duplikuj sales funnel: ${funnel.name}` : undefined}
      okText="Duplikuj"
      cancelText="Anuluj"
      okButtonProps={{ disabled: !finalSlug || finalSlug === funnel?.slug, loading: isSaving }}
      onOk={() => void submit()}
      onCancel={() => {
        setSlug("");
        onCancel();
      }}
      destroyOnClose
      afterOpenChange={(open) => open && inputRef.current?.focus()}
    >
      <Form layout="vertical" onFinish={() => void submit()}>
        <Form.Item label="Nowy slug" required>
          <Input
            ref={inputRef}
            value={slug}
            placeholder={funnel ? `${funnel.slug}-2` : undefined}
            onChange={(event) => setSlug(slugifyWhileTyping(event.target.value))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
